'use client';
import { useFormik } from "formik";
import { useRouter, useSearchParams } from 'next/navigation';
import { useConfig } from "../common/ConfigProvider";
import * as All from '@/element/common/elmntbase';

export default function NewsSearchForm({ data }: any) {
    const config = useConfig();
    const searchParams = useSearchParams();
    const subject = searchParams.get('subject') ?? '';
    const minimumDate = searchParams.get('minimumDate') ?? '';
    const maximumDate = searchParams.get('maximumDate') ?? '';

    const router = useRouter();
    const formik = useFormik({
        initialValues: {
            subject: subject,
            minimumDate: minimumDate,
            maximumDate: maximumDate
        },
        onSubmit: async (values) => {
            let _backpageid = data?.pi_flexform?.data;
            let __pid = _backpageid?.additional?.lDEF['settings.listPid']['vDEF'];
            let _backurl: any = '';

            if (__pid != '') {
                let slugd = config?.pages?.find((pg: any) => {
                    return pg?.uid == __pid;
                });
                _backurl = slugd?.slugurl;
            }

            let _url = _backurl + '?';
            if (searchParams != null && searchParams != undefined) {
                searchParams?.forEach((_prm: any, key: any) => {
                    if (key != "subject" && key != "minimumDate" && key != "maximumDate") {
                        _url = _url + '&' + key + '=' + searchParams.get(key);
                    }
                })
            }
            _url = _url + '&subject=' + values['subject'] + '&minimumDate=' + values['minimumDate'] + '&maximumDate=' + values['maximumDate'];
            router.push(_url);
        },
    });
    return (
           <>
       <div className="news-search-form updatedd">
            <form onSubmit={formik.handleSubmit} >
                <div className="form-group mb-3">
                    <label htmlFor="news-subject" className="form-label">
                        Text
                    </label>
                    <input
                        name='subject'
                        id="news-subject"
                        type="text"
                        className="form-control"
                        onChange={formik.handleChange}
                        value={formik.values['subject']}
                    />
                </div>
                <div className="form-group  mb-3">
                    <label htmlFor="news-minimumDate">Minimum Date</label>
                    <input
                        className="form-control"
                        id="news-minimumDate"
                        type="date"
                        name="minimumDate"
                        onChange={formik.handleChange}
                        value={formik.values['minimumDate']}
                    />
                </div>
                <div className="form-group  mb-3">
                    <label htmlFor="news-maximumDate">Maximum Date</label>
                    <input
                        className="form-control"
                        id="news-maximumDate"
                        type="date"
                        name="maximumDate"
                        onChange={formik.handleChange}
                        value={formik.values['maximumDate']}
                    />
                </div>
                <div >
                    <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={(e) => formik.handleSubmit}
                        disabled={formik.isSubmitting}
                    >Search</button>
                </div>
            </form>
        </div>
        </>
    )
}
